import { ReactNode } from 'react';

import notificationActionTypes from '../actionTypes/notificationActionsTypes';

export type AlertSeverity = 'error' | 'warning' | 'success' | 'info';

export interface INotification {
  id: number | string;
  title: string;
  description: string | ReactNode;
  leftIcon?: ReactNode;
  variant?: AlertSeverity;
  severity?: AlertSeverity;
  linkText?: string;
  linkTo?: string;
  autoClose?: boolean;
  autoHideDuration?: number;
  onLinkClick?: () => void;
}

export interface INotificationData {
  listNotifications: INotification[];
}

export interface INotificationReducer {
  contentData: INotificationData;
  notificationOpen: (notificationData: INotificationData) => void;
  setShowNotification: (showNotification: boolean) => void;
  deleteNotification: (notificationId: string | number) => void;
  clearAllNotifications: () => void;
  showNotification: boolean;
}

export const notificationReducerState: INotificationReducer = {
  contentData: {
    listNotifications: [],
  },
  notificationOpen: () => null,
  setShowNotification: () => null,
  deleteNotification: () => null,
  clearAllNotifications: () => null,
  showNotification: false,
};

const notificationReducer = (
  state: INotificationReducer,
  action: { type: string; payload?: unknown },
): INotificationReducer => {
  const defaultState = state || notificationReducerState;

  switch (action.type) {
    case notificationActionTypes.NOTIFICATION_SET_DATA: {
      const payload = action.payload as { listNotifications: INotification[] };

      return {
        ...defaultState,
        contentData: {
          listNotifications: [...defaultState.contentData.listNotifications, ...payload.listNotifications],
        },
        showNotification: true,
      };
    }

    case notificationActionTypes.NOTIFICATION_SHOW: {
      return {
        ...defaultState,
        showNotification: action.payload as boolean,
      };
    }

    case notificationActionTypes.NOTIFICATION_DELETE: {
      const payload = action.payload as string | number;

      return {
        ...defaultState,
        contentData: {
          listNotifications: defaultState.contentData.listNotifications.filter(({ id }) => id !== payload),
        },
        showNotification: true,
      };
    }

    case notificationActionTypes.NOTIFICATION_CLEAR_ALL: {
      return {
        ...defaultState,
        contentData: {
          listNotifications: [],
        },
        showNotification: false,
      };
    }

    default: {
      return defaultState;
    }
  }
};

export default notificationReducer;
